import React, { useState } from 'react';
import { DISPOSITIONS, LABELS, dispositionOf } from '../../../shared/creatureDisposition';
export default function DispositionControl({ unit, onChange }) {
  const [open,setOpen]=useState(false),[busy,setBusy]=useState(false);
  if (!onChange) return null;
  return <div className="d-inline-block">
    <button type="button" className="btn btn-sm btn-outline-secondary" aria-expanded={open} onClick={()=>setOpen(!open)}>Change Disposition</button>
    {open && <div role="group" aria-label="Party disposition" className="d-flex gap-1 mt-2">
      {DISPOSITIONS.map(value=><button type="button" key={value} className={`btn btn-sm ${dispositionOf(unit)===value?'btn-primary':'btn-outline-secondary'}`}
        aria-pressed={dispositionOf(unit)===value} disabled={busy} onClick={async()=>{setBusy(true);try{if(await onChange(unit.enemyId,value))setOpen(false);}finally{setBusy(false);}}}>{LABELS[value]}</button>)}
    </div>}
  </div>;
}
